import React from 'react'
import FAQItem from "./FaqItem";
import "./index.css"

const Faq = ({ faqData, id }) => {
    return (
        <div id={id} className='section9'>
            <span className='section9Heading'>Frequently Asked Questions</span>
            <div className='accordinContainer'>
                {faqData && faqData?.map((item, index) => (
                    <FAQItem
                        key={index}
                        question={item?.question}
                        answer={item?.answer}
                    />
                ))}

            </div>
        </div>
    )
}

export default Faq;